import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { PureRender } from 'utils/component-helpers';
import 'antd/lib/modal/style/index.less';
import DeedAttendeeAddList from 'retired/DeedAttendeeAddList';

import { selectTerm, selectResults, selectSearchLoading } from './selectors';
import * as Actions from './actions';
import './styles.less';

const InviteAttendeesOverlay = ({
  visible,
  enableSearch,
  searchLoading,
  results,
  term,
  deed,
  actions,
  close,
}) => {
  const inviteAttendees = (deedId, attendeesWithId, attendeesWithEmail) => {
    actions.inviteAttendeesAction(deedId, attendeesWithId, attendeesWithEmail);
  };

  return (
    <DeedAttendeeAddList
      visible={visible}
      enableSearch={enableSearch}
      searchLoading={searchLoading}
      results={results}
      term={term}
      actions={actions}
      deed={deed}
      onAdd={inviteAttendees}
      titleText="Invite Attendees"
      buttonAddText="Invite Attendees"
      close={close}
    />
  );
};

InviteAttendeesOverlay.propTypes = {
  visible: PropTypes.bool,
  term: PropTypes.string,
  results: PropTypes.object,
  enableSearch: PropTypes.bool,
  searchLoading: PropTypes.bool,
  deed: PropTypes.object,
  actions: PropTypes.object,
  close: PropTypes.func,
};

export default connect(
  (state) => ({
    results: selectResults(state),
    searchLoading: selectSearchLoading(state),
    term: selectTerm(state),
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(PureRender(InviteAttendeesOverlay));
